import { render, staticRenderFns } from "./disability-section-question-block.vue?vue&type=template&id=7c73a8ff&scoped=true"
import script from "./disability-section-question-block.vue?vue&type=script&lang=js"
export * from "./disability-section-question-block.vue?vue&type=script&lang=js"
import style0 from "./disability-section-question-block.vue?vue&type=style&index=0&id=7c73a8ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c73a8ff",
  null
  
)

export default component.exports